import { makeObservable, computed, action, observable } from "mobx";
class Loadable {
  _payload;
  state = "initial";
  constructor() {
    makeObservable(this, {
      _payload: observable,
      state: observable,
      setSuccess: action.bound,
      setLoading: action.bound,
      setError: action.bound,
      isLoading: computed,
      isInitial: computed,
      isInitialLoading: computed,
      isFinished: computed,
      isFinishedWithError: computed,
      uiState: computed
    });
  }
  setSuccess(payload) {
    this.state = "success";
    this._payload = payload;
  }
  setLoading() {
    this.state = "loading";
    this._payload = void 0;
  }
  setError() {
    this.state = "error";
    this._payload = void 0;
  }
  get payload() {
    return this._payload;
  }
  get isLoading() {
    return this.state === "loading";
  }
  get isInitial() {
    return this.state === "initial";
  }
  get isInitialLoading() {
    return this.isInitial || this.isLoading;
  }
  get isFinished() {
    return this.state === "success";
  }
  get isFinishedWithError() {
    return this.state === "error";
  }
  get uiState() {
    if (this.state === "initial") {
      return "loading";
    }
    return this.state;
  }
  static toLoadable(promise, transform = (value) => value) {
    const loadable = new Loadable();
    loadable.setLoading();
    promise.then((result) => {
      loadable.setSuccess(transform(result));
    }).catch((e) => {
      loadable.setError();
      console.error("Failed to load data. Error:", e);
    });
    return loadable;
  }
}
export {
  Loadable
};
